import angular from 'angular';

angular.module('cloudX').directive('cxVatNumber', [
  function() {
    return {
      restrict: 'E',
      template: require('./vatNumber.html'),
      scope: {
        field: '=',
        relation: '=',
        save: '&',
        disabled: '=?',
      },
      controller: [
        '$scope',
        '$timeout',
        'flySvc',
        function($scope, $timeout, flySvc) {
          $scope.maskOptions = {
            clearOnBlur: false,
          };
          $scope.identifier = 'vatNumber-' + $scope.$id;

          $scope.oldValue = $scope.relation[$scope.field.id].value;
          $scope.setFocus = function(id) {
            angular.element(document.querySelector('#' + id)).focus();
          };

          function setStatus() {
            $scope.status = 2;

            if ($scope.relation[$scope.field.id].value === null) $scope.status = -1;
            if ($scope.relation[$scope.field.id].value === 'VatPending') $scope.status = 0;
            else if ($scope.relation[$scope.field.id].value === '') $scope.status = 1;
          }
          setStatus();

          $scope.changeFormState = function() {
            if ($scope.status === 0) {
              $scope.vatForm.$cancel();
              $scope
                .save({
                  newValue: 'VatPending',
                })
                .then(function() {
                  $scope.relation[$scope.field.id].value = 'VatPending';
                  $scope.oldValue = 'VatPending';
                });
            } else if ($scope.status === 1) {
              $scope.vatForm.$cancel();
              $scope
                .save({
                  newValue: '',
                })
                .then(function() {
                  $scope.relation[$scope.field.id].value = '';
                  $scope.oldValue = '';
                });
            } else if ($scope.status === 2) {
              //When no VAT liability => show form.
              $timeout(function() {
                $scope.setFocus('vatString');
              }, 50);
            }
          };

          $scope.handleEsc = function($event) {
            if ($event.keyCode === 27) {
              $scope.relation[$scope.field.id].value = $scope.oldValue;
              setStatus();
              $scope.vatForm.$cancel();
            }
          };

          $scope.vatStringClick = function() {
            if ($scope.status === 2) return;
            $scope.status = 2;
            $timeout(function() {
              $scope.setFocus('vatString');
            }, 50);
          };

          $scope.submit = function($data) {
            $scope.field.invalid = false;
            if ($scope.status === 0) {
              return $scope.save({
                newValue: 'VatPending',
              });
            } else if ($scope.status === 1) {
              return $scope.save({
                newValue: '',
              });
            } else {
              // If no value is returned (empty string) we need to save null (if vatNumber is not required).
              // (Convention: null = not filled out, "" = not VAT liable, "VatPending" = pending)
              // BUT if value is undefined entry is incomplete: warning + return '' for xEditable
              if (typeof $data.vatString === 'undefined') {
                $scope.field.invalid = true;
                if ($scope.vatForm.vatString.$error.vatNumber) {
                  flySvc.error(14006);
                } else if ($scope.field.inputMask) {
                  flySvc.message('msgIncompleteEntryInMaskIsNoSave');
                }
                return '';
              }

              if ($data.vatString === '') {
                //If not required, making it empty is allowed => set value to null.
                if (!$scope.field.isRequired) {
                  $scope.status = -1;
                  return $scope
                    .save({
                      newValue: null,
                    })
                    .then(function() {
                      $scope.relation[$scope.field.id].value = null;
                      $scope.oldValue = null;
                    });
                }

                //If vatNumber is required, making it empty is not allowed.
                flySvc.error(3000, ['vatNumber']);

                return '';
              }

              return $scope
                .save({
                  newValue: $data.vatString,
                })
                .then(function() {
                  $scope.relation[$scope.field.id].value = $data.vatString;
                  $scope.oldValue = $data.vatString;
                });
            }
          };

          $scope.$on('$destroy', function() {
            if ($scope.vatForm) $scope.vatForm.$cancel();
          });
        },
      ],
    };
  },
]);
